export class CredentialRenewalRule {
  canRenew: boolean;
  yearsToRenew?: number;
  daysBeforeExpiration?: number;
  daysAfterExpiration?: number;

  constructor(data?: CredentialRenewalRule) {
    if (!data) return;
    this.canRenew = data.canRenew;
    this.yearsToRenew = data.yearsToRenew;
    this.daysBeforeExpiration = data.daysBeforeExpiration;
    this.daysAfterExpiration = data.daysAfterExpiration;
  }
}
